import AccountHighBalanceNotification from './AccountHighBalanceNotification/AccountHighBalanceNotification';
import React from 'react';
import AccountChangeScoreBrandNotification from './AccountChangeScoreBrandNotification/AccountChangeScoreBrandNotification';
import AccountChangeCreditFactorGrade from './AccountChangeCreditFactorGrade/AccountChangeCreditFactorGrade';

const CustomMonitoringModule = props => {
  switch (props?.selectedAlertDetails?.alertSubCategory) {
    case 'ACCOUNT_CREDIT_USAGE':
      return <AccountHighBalanceNotification {...props} />;
    case 'CHANGE_IN_SCORE_BAND':
      return <AccountChangeScoreBrandNotification {...props} />;
    case 'CHANGE_IN_CREDIT_FACTOR_GRADE':
      return <AccountChangeCreditFactorGrade {...props} />;
    default:
      return <></>;
  }
};

export default CustomMonitoringModule;
